import React from 'react'
import useContentType from '../../hooks/useContentType'
import IconTag from '../icon-tag'

const ContentTypeBadge = ({
  primaryType,
  dataTest,
  iconWeight,
  ...props
}) => {
  const { formatIcon, label } = useContentType({ primaryType })

  // Only Phosphor icons accept `weight`; the MUI SvgIcon fallback for unknown
  // formats would forward it to the DOM (<svg weight=...>) and trigger a React
  // unknown-attribute warning. Phosphor icons always carry a `weight` prop.
  const isPhosphorIcon =
    React.isValidElement(formatIcon) && formatIcon.props.weight !== undefined

  const icon = iconWeight && isPhosphorIcon
    ? React.cloneElement(formatIcon, { weight: iconWeight })
    : formatIcon

  return (
    <IconTag
      icon={icon}
      text={label}
      data-test={dataTest}
      {...props}
    />
  )
}

export default ContentTypeBadge
